import logAxios from '../../utils/logAxios';
import appAxios from '../../utils/appAxios';
import JwtService from "@/core/services/JwtService";



export default {
    namespaced: true,

    state: {

        User: {
            FirstName: null,
            LastName: null,
            Email: null,
            Id: null,
            Phone: null,
            Company: null,
            CompanyId: null,
            PermissionNames: [],
            AvatarUrl: null
        },
        userRole: ""

    },
    getters: {

        _isAuthorization: (state) => state.User.Email !== null ? true : false,
        _getUser: (state) => state.User,

    },
    mutations: {

        SET_AUTH(state, Data) {
            if (Data !== undefined) {
                JwtService.saveToken(Data.AccessToken)
                state.User.FirstName = Data.Info.Firstname
                state.User.LastName = Data.Info.Lastname
                state.User.Email = Data.Info.Email
                state.User.Id = Data.Info.Id
                state.User.Phone = Data.Info.Phone
                state.User.Company = Data.Info.Company
                state.User.CompanyId = Data.Info.CompanyId
                state.User.PermissionNames = Data.Info.PermissionNames;
                state.User.AvatarUrl = Data.Info.AvatarUrl === "" ? null : Data.Info.AvatarUrl;
            }
        },

        LOG_OUT(state) {

            JwtService.destroyToken()
            Object.keys(state.User).forEach(item => state.User[item] = null)
        },
        SET_USER_PROFILE_IMG(state, url) {
            state.User.AvatarUrl = url
        }
    },
    actions: {

        async GET_LOGİN({ commit }, data) {
            return new Promise((resolve) => {
                logAxios.post("/token/login", data).then(responseLogin => {
                    if (responseLogin.data.Success) {
                        commit("SET_AUTH", responseLogin.data.Data)
                        appAxios.defaults.headers.Authorization = `Bearer ${responseLogin.data.Data.AccessToken}`
                        resolve(responseLogin.data)
                    } else {
                        resolve(responseLogin.data)
                    }
                })

            })
        },
        async SAVE_PROFILE_IMAGE({ commit, state }, payload) {
            return new Promise(resolve => {
                appAxios.post('/user/uploadprofilepicture', payload).then(response => {
                    resolve(response.data.Success)
                    if (response.data.Success) {
                        commit("SET_USER_PROFILE_IMG", response.data.Data.AvatarUrl)
                    }
                }).catch((err) => { resolve(false) })
            })
        },

        async DELETE_PROFILE_IMAGE({ commit, state }) {
            return new Promise(resolve => {
                appAxios.get('/User/DeleteProfilePicture').then(response => {
                    resolve(response.data.Success)
                    if (response.data.Success) {
                        commit("SET_USER_PROFILE_IMG", null)
                    }
                }).catch((err) => { resolve(false) })
            })
        },

        async SET_USER_LANG(_, payload) {
            return new Promise(resolve => {
                appAxios
                    .get(`/User/UpdateLanguage?languageId=${payload}`).then(response => {
                        resolve(response.data.Success)
                    }).catch(() => resolve(false))
            })
        },

        async REGISTER(_, payload) {
            return new Promise(resolve => {
                appAxios.post('/Token/Register', payload).then((response) => {
                    resolve(response.data.Success)
                }).catch(() => resolve(false))
            })
        }
    },


}